import { render, staticRenderFns } from "./NombreRazonSocialAcreedorDeudor.vue?vue&type=template&id=aaba8edc&scoped=true&"
import script from "./NombreRazonSocialAcreedorDeudor.vue?vue&type=script&lang=js&"
export * from "./NombreRazonSocialAcreedorDeudor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaba8edc",
  null
  
)

export default component.exports